import './App.css';
// Temporary orbit-navigation prototype. Restore './general.js' to recover the original UI.
import General from './generalPrototype.js';

function App() {
  document.title = "Anran Xu";
  return (
    <div className="App">
      <General />
    </div>
  );
}

export default App;
